import { useEffect } from 'react';

import { useGetRecipeByIdOrSlug } from '~/src/queries/api-ecom/generated/api-ecom';
import useServings from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/hooks/useServings';

const useRecipe = (slug: string) => {
  const { servings, handleChangeServings, handleInitialServings } = useServings();

  const { data: recipe, error } = useGetRecipeByIdOrSlug(
    slug,
    servings ? { servings } : undefined,
    {
      query: { keepPreviousData: true },
    },
  );

  useEffect(() => {
    handleInitialServings(prev => prev ?? recipe?.servings);
  }, [handleInitialServings, recipe?.servings]);

  return {
    recipe,
    servings,
    handleChangeServings,
    error,
  };
};

export default useRecipe;
